import FullScreenLoader from "app/components/loader/FullScreenLoader";
import PageWrapper from "app/components/page-wrapper/page-wrapper";
import SubscribeForm from "app/components/subscribe-form/subscribe-form";
import { idoFilters, idoPageData } from "app/config";

import { FC } from "react";
import { useGetIdosQuery } from "store/api/new.api";
import { useAccount } from "wagmi";
import IdoProject from "../components/main-projects/IdoProject";
import styles from "./app-main.module.scss";

const AppMainPage: FC = () => {
  const { address } = useAccount();
  const { data: idos, isLoading } = useGetIdosQuery({
    address,
    page: 1,
    limit: 100,
  });

  if (isLoading || !idos) {
    return <FullScreenLoader isLoading={isLoading} />;
  }

  return (
    <PageWrapper>
      <div className={styles.main}>
        <div className={styles.content}>
          <div className={styles.wrapper}>
            <IdoProject
              search={false}
              data={{ items: idos.list ?? [] }}
              title={idoPageData.title}
              description={idoPageData.description}
              filters={idoFilters}
            />
            <SubscribeForm />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default AppMainPage;
